import React, { useRef } from "react";
import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import { message } from "antd";
import badge1 from "../../assets/image/badge-1.webp";
import badge2 from "../../assets/image/badge-2.webp";
import badge3 from "../../assets/image/badge-3.webp";
import badge4 from "../../assets/image/badge-4.webp";
import badge5 from "../../assets/image/badge-5.webp";

export const PRESET_BADGES = [
  { id: "badge-1", src: badge1 },
  { id: "badge-2", src: badge2 },
  { id: "badge-3", src: badge3 },
  { id: "badge-4", src: badge4 },
  { id: "badge-5", src: badge5 },
];

const BadgeLogoPicker = ({
  selectedLogo,
  onSelectPreset,
  onCustomUpload,
  customPreview,
  bgcolorBadge,
}) => {
  const fileInputRef = useRef(null);
  const isCustomSelected = selectedLogo === "custom";
  const previewSrc = customPreview || null;

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      message.error("Please upload an image file");
      return;
    }
    if (file.size > 1 * 1024 * 1024) {
      message.error("File size exceeds 1MB limit");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      onCustomUpload(reader.result, file);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="badgeLogoPicker" style={{ marginTop: 15 }}>
      <div className="badgeLogoPickerAdd">
        <p className="badgeLogoPickerLabel">Add Logo</p>
        <div
          className={`badgeLogoPickerUpload${isCustomSelected ? " selected" : ""}`}
          // style={
          //   previewSrc
          //     ? { backgroundColor: bgcolorBadge || "#2e3192" }
          //     : undefined
          // }
          onClick={() => {
            if (previewSrc) onSelectPreset("custom");
          }}
          role={previewSrc ? "button" : undefined}
          tabIndex={previewSrc ? 0 : undefined}
          onKeyDown={(e) => {
            if (previewSrc && (e.key === "Enter" || e.key === " ")) {
              e.preventDefault();
              onSelectPreset("custom");
            }
          }}
        >
          {previewSrc ? (
            <div
              className="badgeLogoPickerUploadImage"
              style={{
                backgroundColor: bgcolorBadge || "#2e3192",
                borderRadius: `50%`,
                border: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 55,
                width: 55,
              }}
            >
              <img src={previewSrc} alt="Custom logo preview" />
            </div>
          ) : (
            <div className="badgeLogoPickerChecker" />
          )}
          {isCustomSelected && previewSrc && (
            <span className="badgeLogoPickerCheck" aria-hidden="true">
              <CheckOutlined />
            </span>
          )}
          <button
            type="button"
            className="badgeLogoPickerPlus"
            aria-label="Upload custom logo"
            onClick={(e) => {
              e.stopPropagation();
              fileInputRef.current?.click();
            }}
          >
            <PlusOutlined />
          </button>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            hidden
            onChange={handleFileChange}
          />
        </div>
      </div>

      <span className="badgeLogoPickerOr">or</span>

      <div className="badgeLogoPickerPresets">
        <p className="badgeLogoPickerLabel">Pre-sets Logo</p>
        <div className="badgeLogoPickerPresetList">
          {PRESET_BADGES.map((badge) => {
            const isSelected = selectedLogo === badge.id;
            return (
              <button
                type="button"
                key={badge.id}
                className={`badgeLogoPickerPreset${isSelected ? " selected" : ""}`}
                onClick={() => onSelectPreset(badge.id, badge.src)}
                aria-label={`Select ${badge.id}`}
                aria-pressed={isSelected}
              >
                <div
                  className="badgeLogoPickerPresetImage"
                  style={{
                    padding: 0,
                    backgroundColor: `${bgcolorBadge}`,
                    borderRadius: `50%`,
                    border: "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 55,
                    width: 55,
                  }}
                >
                  <img src={badge.src} alt="" />
                </div>
                {isSelected && (
                  <span className="badgeLogoPickerCheck" aria-hidden="true">
                    <CheckOutlined />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BadgeLogoPicker;
